import { s_blog } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import CenterContainer from '../../../common/CenterContainer'
import BlogCard from '../BlogCard'

const BlogDetailDesktopRecommendSection = ({ recommendList }) => {
  const { t } = useTranslation()
  return (
    <>
      {recommendList && (
        <div className={style.outerLayout}>
          <CenterContainer clx="bg-gray-50">
            <div className={style.innerLayout}>
              <div className={style.title}>{t(s_blog.recommen_post)}</div>
              <div className={style.postSectionWrapper}>
                {recommendList.map((postItem, i) => {
                  return (
                    <BlogCard
                      key={i}
                      title={postItem.title}
                      subtitle={postItem.subtitle}
                      thumbnail={postItem.thumbnail}
                      slug={postItem.slug.current}
                      tagLists={postItem.tagList}
                      category={postItem.category}
                      subCategory={postItem.subCategory}
                    />
                  )
                })}
              </div>
            </div>
          </CenterContainer>
        </div>
      )}
    </>
  )
}

export default BlogDetailDesktopRecommendSection

const style = {
  outerLayout: `bg-gray-50`,
  innerLayout: `mb-[120px] mt-[60px] bg-gray-50`,
  title: `Title1-20Bd mb-[16px]`,
  postSectionWrapper: `flex flex-row gap-[16px]`,
}
